import "./AboutUs.css";

function AboutUs() {

    return (

        <div className="about-us-page">

            <div className="about-us-container">

                <span className="section-tag">
                    OUR STORY
                </span>

                <h1>
                    FarmFox's Journey
                </h1>

                <p>
                    FarmFox was born with a vision to bring the finest quality
                    Makhana from the sacred ponds of Mithila, Bihar, to homes
                    across India. We work closely with local farmers who have
                    cultivated Makhana for generations, preserving traditional
                    practices while embracing modern quality standards.
                </p>

                <p>
                    Every FarmFox product begins with carefully selected fox
                    nuts that are naturally harvested, thoroughly cleaned, and
                    graded to ensure superior quality. Our commitment is to
                    deliver products that are fresh, wholesome, and packed with
                    nutrition while maintaining the authentic taste of premium
                    Mithila Makhana.
                </p>

                <p>
                    Rich in protein, naturally gluten-free, and low in calories,
                    Makhana is one of India's oldest superfoods. At FarmFox,
                    we believe healthy snacking should be both delicious and
                    accessible. From sourcing to packaging, every step reflects
                    our promise of purity, freshness, and uncompromising quality.
                </p>

                <div className="about-us-highlight">

                    <div className="about-us-highlight-card">
                        <h3>🌾 Authentic Sourcing</h3>
                        <p>
                            Premium Makhana sourced directly from trusted
                            farmers in Mithila.
                        </p>
                    </div>

                    <div className="about-us-highlight-card">
                        <h3>💚 Healthy Lifestyle</h3>
                        <p>
                            High Protein • Low Calorie • Gluten Free •
                            Naturally Nutritious
                        </p>
                    </div>

                    <div className="about-us-highlight-card">
                        <h3>⭐ Our Promise</h3>
                        <p>
                            Freshness, Quality, Authenticity and Customer
                            Satisfaction in every pack.
                        </p>
                    </div>

                </div>

            </div>

        </div>

    );

}

export default AboutUs;